import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from "@mui/material";
import { useFlow } from "../context/FlowContext";
import { useI18N } from '../context/I18NContext';
import { BoxContainer } from '../layouts/Theme';
export default function Checkout(props) {
    const flow = useFlow();
    const theme = useTheme();
    const { t } = useI18N();
    const [selected, setSelected] = useState(false);
    const handleSelect = (e) => {
        let value = e.target.closest('li').getAttribute('rel');
        if (selected === value) {
            setSelected(false);
        }
        else {
            setSelected(value);
        }
    };
    const handleClick = () => {
        // @ts-ignore
        flow === null || flow === void 0 ? void 0 : flow.onNext();
    };
    const providers = [
        {
            name: t("Betaal met iDeal"),
            image: "https://www.mollie.com/external/icons/payment-methods/ideal.png",
            subtitle: "25 cent transactiekosten"
        },
        {
            name: t("Betaal met PayPal"),
            image: "https://www.mollie.com/external/icons/payment-methods/paypal.png",
            subtitle: "5 procent transactiekosten over het totaal"
        },
        {
            name: t("Betaal met BanContact"),
            image: "https://www.mollie.com/external/icons/payment-methods/bancontact.png",
            subtitle: "50 cent transactiekosten"
        },
        {
            name: t("Betaal met SOFORT"),
            image: "https://www.mollie.com/external/icons/payment-methods/sofort.png",
            subtitle: "50 cent transactiekosten"
        }
    ];
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { variant: "h6", component: "div", sx: { flexGrow: 1 }, children: "Totaal: \u20AC 49,95" }), _jsx(Typography, { variant: "subtitle2", component: "div", sx: { flexGrow: 1 }, children: "Hoe wil je afrekenen?" }), _jsx(List, { sx: { width: '100%', bgcolor: 'background.paper' }, children: providers.map((row, i) => (_jsxs(ListItem, { onClick: handleSelect, rel: i.toString(), sx: {
                        border: "#eee 1px solid",
                        cursor: 'pointer',
                        paddingTop: 0,
                        backgroundColor: selected === i.toString() ? theme.palette.primary.main : '#fff',
                        color: selected === i.toString() ? '#fff' : '#000',
                        borderRadius: '4px',
                        my: 0,
                        boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
                        "&:hover": {
                            backgroundColor: selected === i.toString() ? theme.palette.primary.main : '#efefef',
                            // color: '#fff !important',
                            // "& .MuiListItemText-secondary": {
                            //     color: '#fff',
                            // }
                        },
                        "& .MuiListItemText-secondary": {
                            color: selected === i.toString() ? '#fff' : '#000',
                        }
                    }, children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, { src: row.image }) }), _jsx(ListItemText, { sx: {}, primary: row.name, secondary: row.subtitle })] }, i))) }), _jsx(Button, { onClick: handleClick, disabled: !selected, fullWidth: true, sx: { my: 1 }, variant: "contained", children: "Verder met betalen" })] }));
}
